import en from "./data-protection-en"
import de from "./data-protection-de"
import es from "./data-protection-es"
export default {
    en: en,
    de: de,
    es: es
} as any